import { z } from "zod";

export const profileFormSchema = z.object({
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  phone: z.string()
    .regex(/^04\d{8}$/, "Must be a valid Australian mobile number")
    .optional(),
  date_of_birth: z.date()
    .min(new Date('1900-01-01'), "Date must be after 1900")
    .max(new Date(), "Date cannot be in the future")
    .optional(),
  address: z.string().optional(),
  occupation: z.string().optional(),
  tfn: z.string()
    .regex(/^\d{9}$/, "TFN must be exactly 9 digits")
    .optional(),
  avatar_url: z.string().optional(),
});

export type FormValues = z.infer<typeof profileFormSchema>;